import React, { Component } from 'react';

import withData from '../utils/withData';
import Site, {SiteModifier_} from '../utils/Site'
import Each from '../utils/Each'

import Base from '../components/BaseComponent'
import Intro from '../components/Intro'
import Item from '../components/Item'
import Content from '../components/Content'
import Grid from '../components/Grid'
import List from '../components/Lists'
import Link from '../components/Link'
import Media from '../components/Media'
import Newsletter from '../components/Newsletter'
import Button from '../components/Button'
import Image from '../components/Image'
import Filters from '../components/Filters'
import EventsList from '../components/EventsList'
import FadeIn from '../components/FadeIn'
import ContentBlocks from '../components/ContentBlocks'

import Asset from '../models/Asset'
import Entry from '../models/Entry'



class Compare extends Component {


  constructor(props) {
    super(props);

    this.state = {
      properties: {}
    }
  }

  componentWillMount() {
    let _this = this
    this.amenities = this.props.data.amenities
    this.properties = this.props.data.entries.filter(entry => {
        return entry.locationCategory == 'live' && entry.section == 'locations'
    });

    let propers = {}
    this.properties.map(property => {
        propers[property.id] = true
    })

    this.setState({show:propers})

  }

  componentWillUnmount() {

  }

  listProperties(amenity) {
      return this.properties.map(property => {
        return(
        <li className={'List-item List-item--'+ (property.amenities.indexOf(amenity) > -1 ? 'checked':'unchecked') + (this.state.show[property.id] === true ? ' is-active':'')}><Content modifier={'yellow'}><h4>{property.title}  </h4></Content></li>
      )})
  }

  toggleProperty(pid)
  {
    let propers = this.state.show
    propers[pid] = !propers[pid]
    this.setState({show: propers});
    console.log(this.state.properties)
  }

  propertyNav()
  {
    let _this = this
    return this.properties.map(property => {
      return(
        <li className={'List-item ' + (_this.state.show[property.id] === true ? 'is-active':'')} onClick={()=>{_this.toggleProperty(property.id)}}><Link url={"#"} modifiers={['filter', ]} title={property.title} blank={false}  /></li>
      )
    })
  }


  /*

    RENDER

  */

  render() {

    let _this = this


    let amenitiesList = this.amenities.map(function(amenity) {

      let title = amenity.title;

      return (<div className="Grid-item">

        <Item modifiers={['amenities']}>

          <div className="Item-head">

            <Content>
              <h4>{title}</h4>
            </Content>

          </div>
          <div className="Item-body">

           <ul className="List  List--amenities">
              {_this.listProperties(amenity.id)}
            </ul>

          </div>

        </Item>
      </div>);


    })

    return (
      <FadeIn>
      <div className="Template  Template--default  Template--compare">

          {/* Template-head */}
          <div className="Template-head">

            <Content>



            </Content>
          </div>
          {/* / Template-head */}

          {/* Template-body */}
          <div className="Template-body">

            <div className="Template-sections">

              <div className="Template-section  Template-section--full">

                <div className="Template-heading">

                  <Content modifier={'yellow'} >
                    <h1> Compare </h1>
                  </Content>

                  <List modifiers={['filters']}>
                  {this.propertyNav()}
                  </List>

                </div>

                <div className="Template-content">

                  <Grid modifiers={['2']}>

                    {amenitiesList}

                  </Grid>

                </div>

              </div>

            </div>


          </div>
          {/* / Template-body */}


      </div>
      </FadeIn>
    );

  }
}

export default withData(Compare);



// WEBPACK FOOTER //
// ./src/js/templates/Compare.js